import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Card, CardMedia, Container, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CustomCard from "../../../components/CustomCard/CustomCard";
import Select from "../../../components/Select/Select";
import TopBar from "../../../components/TopBar/TopBar";
import api, { superTailsApi } from "../../../redux/actions/api";
import "./Home.css";

import { uniq } from "lodash";
import moment from "moment";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import {
  checkedCallInApi,
  checkedInApi,
  clinicReassignAppointment,
  clinicRescheduleAppointment,
  getAppointmentsByVetIdAndDate,
  getAvailabilityByVetIdAndType,
  getClinicDashboardData,
  getClinicHolidays,
  getUserDetailsById,
  updateCancel,
  updateCompleted,
  updateFinalize,
} from "../../../redux/reducers/clinicSlice";
import { getVetHolidaysById } from "../../../redux/reducers/doctorSlice";
import { hideLoader, showLoader } from "../../../redux/reducers/loaderSlice";
import { getMedicalHistoryByPetId } from "../../../redux/reducers/medicalHistorySlice";
import { storeHomeScreenDetails } from "../../../redux/reducers/mixedSlice";
import { admitPet } from "../../../redux/reducers/petSlice";
import { getClinicVets } from "../../../redux/reducers/vetSlice";
import { AppColors } from "../../../util/AppColors";
import { appointmentLaterList, appointmentList } from "../../../util/dropList";
import {
  adjustTime,
  getAllDatesFromArray,
  getRequiredSlotList,
  getUpcoming60Dates,
} from "../../../util/function";
import { superTailsClinicId } from "../../../util/server";
import BookAnAppointment from "../../CommonScreens/BookAppointmentment/BookAnAppointment";
import MedicalHistoryView from "../ClinicPetDetails/MedicalHistory/MedicalHistoryView";
import HomeVisit from "./HomeVisit";
// import Inpatient from "./Inpatient";
import InpatientNew from "./InpatientNew/InpatientNew";

const cardSty = {
  borderRadius: 1,
  padding: 2,
  borderTopColor: AppColors.appPrimary,
};

const initBookValues = {
  bookingType: "Phone",
  consultationMode: "Physical",
  serviceType: null,
  reason: "",
  vetName: null,
  appointmentOption: "",
  date: new Date(),
};

const initAdmitValues = { kennelNumber: "", remark: "", vet: null };
const initAdmitErrors = { kennelNumber: false, remark: false, vet: false };
const initErrors = { appointmentDate: "", appointmentTime: "", doctor: "" };

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(
    location?.state?.selectedTab ?? "Outpatient"
  );
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [petData, setPetData] = useState(null);
  const [errors, setErrors] = useState(initErrors);
  const [bookValues, setBookValues] = useState(initBookValues);
  const [isReassign, setIsReassign] = useState(true);
  const [modalData, setModalData] = useState(null);
  const [vets, setVets] = useState([]);
  const [vetListWithAll, setVetListWithAll] = useState([]);
  const allObj = { name: "All", value: "All", id: 1 };
  const [selectedVet, setSelectedVet] = useState(allObj);
  const [selectTime, setSelectTime] = useState(null);
  const [delModVisible, setDelModVisible] = useState(false);
  const [rescheduleModVsble, setRescheduleModVsble] = useState(false);
  const [followUpModVsble, setFollowUpModVsble] = useState(false);
  const [selectTimeIdError, setSelectTimeIdError] = useState(false);
  const [admitModVisible, setAdmitModVisible] = useState(false);
  const [admitValues, setAdmitValues] = useState(initAdmitValues);
  const [admitErrors, setAdmitErrors] = useState(initAdmitErrors);
  const [holidayDates, setHolidayDates] = useState([]);
  const holidays = useSelector((state) => state?.doctor?.holidays);
  const clinicHolidays = useSelector((state) => state?.clinic?.holidays);
  const dashboard = useSelector((state) => state.clinic.dashboard);
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const { vetAvailability, vetBookedApnts, userDetails } = useSelector(
    (state) => state?.clinic
  );
  const user = localStorage.getItem("user");
  const role = localStorage.getItem("role");
  const profile = JSON.parse(user);

  useEffect(() => {
    checkLocalStorageforReload();
    getProfile(); // get and store user details
    dispatch(getClinicVets());
    dispatch(getClinicHolidays());
  }, []);

  useEffect(() => {
    if (
      isReassign ||
      !bookValues?.vetName?.value ||
      !bookValues?.date ||
      !bookValues?.appointmentOption
    ) {
      return;
    }
    if (bookValues?.appointmentOption === "Later") {
      dispatch(getVetHolidaysById(bookValues?.vetName?.value));
      dispatch(
        getAvailabilityByVetIdAndType({
          vetId: bookValues?.vetName?.value,
          type: bookValues?.consultationMode,
        })
      );
      dispatch(
        getAppointmentsByVetIdAndDate({
          vetId: bookValues?.vetName?.value,
          date: moment(new Date(bookValues?.date)).format("YYYY-MM-DD"),
          clinicId: profile?.id,
        })
      );
    }
  }, [
    bookValues?.vetName?.value,
    bookValues?.date,
    bookValues?.appointmentOption,
    bookValues?.consultationMode,
  ]);

  useEffect(() => {
    const reqVetList = clinicVets
      ?.filter((vl) => {
        if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
          return vl;
        }
      })
      ?.map((vet) => {
        return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
      });
    setVets(
      [
        {
          name: `${
            role === "ROLE_CLINIC" ? profile?.name : userDetails?.name
          } (Clinic)`,
          value: role === "ROLE_CLINIC" ? profile?.id : userDetails?.id,
          id: role === "ROLE_CLINIC" ? profile?.id : userDetails?.id,
        },
      ].concat(reqVetList)
    );
    setVetListWithAll(
      [
        allObj,
        {
          name: `${
            role === "ROLE_CLINIC" ? profile?.name : userDetails?.name
          } (Clinic)`,
          value: role === "ROLE_CLINIC" ? profile?.id : userDetails?.id,
          id: role === "ROLE_CLINIC" ? profile?.id : userDetails?.id,
        },
      ].concat(reqVetList)
    );
  }, [clinicVets]);

  useEffect(() => {
    // Refetch the dashboard data whenever the selected veterinarian changes
    if (selectedTab === "Outpatient" || selectedTab === "Virtual") {
      const reqObj = { type: selectedTab };
      if (selectedVet?.value !== "All")
        reqObj.url = `&doctorId=${selectedVet?.value}`;
      dispatch(getClinicDashboardData(reqObj));
    }
  }, [selectedVet]);

  useEffect(() => {
    getHolidayDateList();
  }, [holidays, clinicHolidays, vetAvailability]);

  const getHolidayDateList = () => {
    if (
      (holidays?.length === 0 || !holidays) &&
      (clinicHolidays?.length === 0 || !clinicHolidays) &&
      vetAvailability?.every((li) => li?.status)
    ) {
      return setHolidayDates([]);
    }
    const vetDates = getAllDatesFromArray(holidays) ?? [];
    const cliHolidays =
      clinicHolidays?.map((hl) => {
        return hl?.date;
      }) ?? [];
    const unAvilableDates =
      vetAvailability?.length > 0 ? getUpcoming60Dates(vetAvailability) : [];
    const mergedArray = vetDates?.concat(cliHolidays, unAvilableDates);
    setHolidayDates(uniq(mergedArray));
  };

  const createModalOpen = (li, reAssign = false) => {
    setIsReassign(reAssign);
    setRescheduleModVsble(!rescheduleModVsble);
    setModalData(li);
    const apnt = li?.appoinment;
    setBookValues({
      ...bookValues,
      appointmentTime: apnt?.appointmentTime ?? apnt?.appointmentStartTime,
      appointmentId: apnt?.appointmentId,
      appointmentDate: apnt?.appointmentDate,
      bookingType: "Walk-in",
      consultationMode: apnt?.appointmentType,
      serviceType: apnt?.serviceType,
      reason: apnt?.reason,
      vetName: vets?.find((vet) => vet?.value === apnt?.doctorId) ?? null,
      appointmentOption: apnt?.immediate ? "Immediate" : "Later",
      date: new Date(apnt?.appointmentDate),
    });
  };

  const rescheduleModClose = () => {
    setIsReassign(false);
    setRescheduleModVsble(false);
    setModalData(null);
    setBookValues(initBookValues);
    setSelectTimeIdError(false);
    setErrors(initErrors);
    setSelectTime(null);
  };

  const createModalOpenFollowUp = (li) => {
    setFollowUpModVsble(!followUpModVsble);
    setModalData(li);
    setIsReassign(false);
    setBookValues({
      ...initBookValues,
      serviceType: { name: "Follow-up", value: "Follow-up" },
    });
  };

  const onCloseFollowUpMod = () => {
    setFollowUpModVsble(false);
    setRescheduleModVsble(false);
    setBookValues(initBookValues);
    setModalData(null);
    setSelectTime(null);
    setSelectTimeIdError(false);
    setErrors(initErrors);
  };

  const handleDelModClose = (li) => {
    setDelModVisible(!delModVisible);
    setModalData(li);
  };

  const handleSelectTime = (time) => {
    setSelectTime(time?.startTime);
    setSelectTimeIdError(false);
  };

  const validateFields = () => {
    const newErrors = {};
    if (!bookValues?.vetName?.value)
      newErrors.vetName = "This field is required";
    if (!bookValues?.appointmentOption)
      newErrors.appointmentOption = "Appointment Type is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const checkLocalStorageforReload = async () => {
    const videoCallPageReloaded = await JSON.parse(
      localStorage.getItem("videoCallPageReloaded")
    );
    if (videoCallPageReloaded) {
      navigate(`/clinic-pet-details`, {
        state: { appointment: { appoinment: videoCallPageReloaded?.state } },
      });
      return localStorage.removeItem("videoCallPageReloaded");
    }
  };

  const getProfile = async () => {
    api({ contentType: true, auth: true })
      .get("/user/profile")
      .then((res) => {
        localStorage.setItem("user", JSON.stringify(res?.data?.data));
        if (role !== "ROLE_CLINIC" && res?.data?.data?.createdBy) {
          dispatch(getUserDetailsById(res?.data?.data?.createdBy));
        }
      });
  };

  const navigatePetDetailsScreen = (appointment) => {
    navigate(`/clinic-pet-details`, { state: { appointment } });
  };

  const filterAppointmentsByVet = (typ) => {
    return dashboard?.[typ]?.filter((itm) => !itm?.appoinment?.inpatient);
  };

  const filterAppointments = (data, type) =>
    data.filter((item) => item.appoinment.appointmentType === type);

  const handleAdmit = (item) => {
    setModalData(item);
    setAdmitModVisible(true);
  };

  const handleSelectedTab = (tab) => {
    setSelectedTab(tab);
    //for storing details to call socket
    dispatch(
      storeHomeScreenDetails({
        selectedTab: tab,
        selectedVet: selectedVet?.value !== "All" ? selectedVet?.value : null,
      })
    );
    if (tab === "Outpatient") {
      dispatch(getClinicDashboardData({ type: "Outpatient" }));
    }
    if (tab === "Virtual") {
      dispatch(getClinicDashboardData({ type: "Virtual" }));
    }
  };

  const renderSection = (
    title,
    data,
    colorClass,
    sectionType,
    checkIn,
    threedots
  ) => (
    <div className="w20Per borderRight">
      <div className="flex-row">
        <div className="p10MinWid99Per ">
          <Typography
            className={`card-head-${colorClass}-color card-head-border-bottom-${colorClass} font-bold fs20`}
          >
            {title} ({data?.length ?? 0})
          </Typography>
          <CustomCard
            list={data ?? []}
            dashboard
            sectionType={sectionType}
            onClickResch={(li) => createModalOpen(li, false)}
            onReassign={(li) => createModalOpen(li, true)}
            handleAction={(li) => handleAction(li)}
            handleCancel={(li) => handleDelModClose(li)}
            handleCompleted={(li) => handleCompleted(li)}
            onFollowUp={(li) => {
              createModalOpenFollowUp(li);
            }}
            onClick={(li) => navigatePetDetailsScreen(li)}
            checkIn={checkIn}
            threedots={threedots}
            handleConsult={(li) => handleConsult(li)}
            handleCheckout={(li) => handleCheckout(li)}
            handleAdmit={(itm) => handleAdmit(itm)}
          />
        </div>
      </div>
    </div>
  );

  const handleAction = (li, action) => {
    const data = {
      appointmentId: li?.appoinment?.appointmentId,
      doctorId: li?.appoinment?.doctorId,
    };
    dispatch(checkedInApi(data)).then((res) => {
      if (res?.payload) {
        dispatch(getClinicDashboardData({ type: selectedTab }));
      }
    });
  };

  const handleCancel = () => {
    dispatch(updateCancel(modalData?.appoinment?.appointmentId)).then((res) => {
      if (res?.payload) {
        setDelModVisible(false);
        setRescheduleModVsble(false);
        dispatch(getClinicDashboardData({ type: selectedTab }));
      }
    });
  };

  const handleConsult = (li, action) => {
    const data = {
      appointmentId: li?.appoinment?.appointmentId,
      doctorId: li?.appoinment?.doctorId,
    };
    dispatch(checkedCallInApi(data)).then((res) => {
      if (res?.payload) {
        if (
          role !== "ROLE_CLINIC" &&
          profile?.id !== li?.appoinment?.doctorId
        ) {
          const form = new FormData();
          form.append("doctorId", profile?.id);
          dispatch(
            clinicReassignAppointment({
              appointmentId: li?.appoinment?.appointmentId,
              form,
            })
          )?.then((apiRes) => {
            if (apiRes?.payload) {
              dispatch(getClinicDashboardData({ type: selectedTab }));
            }
          });
        } else {
          dispatch(getClinicDashboardData({ type: selectedTab }));
        }
      }
    });
  };

  const handleCompleted = (li, action) => {
    dispatch(updateFinalize(li?.appoinment?.appointmentId)).then((res) => {
      if (res?.payload) {
        dispatch(getClinicDashboardData({ type: selectedTab }));
      }
    });
  };

  const handleCheckout = (li, action) => {
    dispatch(updateCompleted(li?.appoinment?.appointmentId)).then((res) => {
      if (res?.payload) {
        if (
          profile?.createdBy === superTailsClinicId ||
          profile?.id === superTailsClinicId
        ) {
          dispatch(
            getMedicalHistoryByPetId({
              petId: li?.appoinment?.petId,
              url: `?type=all&page=1&itemSize=5`,
            })
          ).then((res2) => {
            if (res2?.payload?.data) {
              const apnt = li?.appoinment;
              setSelectedHistory(res2?.payload?.data?.[0]);
              setPetData({
                petName: apnt?.petName,
                breed: apnt?.breed,
                gender: apnt?.gender,
                dob: apnt?.dob,
                userName: apnt?.userName,
                petData: apnt?.mobile,
              });
            }
          });
        }
        dispatch(getClinicDashboardData({ type: selectedTab }));
      }
    });
  };

  const handleReschedule = () => {
    if (
      !isReassign &&
      !selectTime &&
      bookValues?.appointmentOption !== "Immediate"
    ) {
      return setSelectTimeIdError(true);
    }
    if (!validateFields()) return;
    const apntId = modalData?.appoinment?.appointmentId;
    if (isReassign) {
      dispatch(showLoader());
      const form = new FormData();
      form.append("doctorId", bookValues?.vetName?.value);
      dispatch(clinicReassignAppointment({ appointmentId: apntId, form })).then(
        (res) => {
          if (res?.payload) {
            onCloseFollowUpMod();
            setModalData(null);
          }
        }
      );
      dispatch(hideLoader());
    } else {
      dispatch(showLoader());
      const data = {
        appointmentDate: moment(new Date(bookValues?.date)).format(
          "YYYY-MM-DD"
        ),
        doctorId: bookValues?.vetName?.value,
        appointmentStartTime: selectTime,
      };
      data.appointmentEndTime = adjustTime(
        selectTime,
        getRequiredSlotList({
          availability: vetAvailability,
          date: bookValues?.date,
          isDuration: true,
        })
      );
      dispatch(
        clinicRescheduleAppointment({ appointmentId: apntId, data })
      ).then((res) => {
        if (res?.payload) {
          onCloseFollowUpMod();
          setModalData(null);
        }
      });
      dispatch(hideLoader());
    }
  };

  const onCloseAdmitModal = () => {
    setAdmitModVisible(false);
    setAdmitValues(initAdmitValues);
    setAdmitErrors(initAdmitErrors);
    setModalData(null);
  };

  const handleAdmitChange = (name, value) => {
    setAdmitValues({ ...admitValues, [name]: value });
    setAdmitErrors({
      ...admitErrors,
      [name]:
        value !== "" && value !== null
          ? false
          : name === "kennelNumber"
          ? false
          : true,
    });
  };

  const handleAdmitPatient = () => {
    if (
      // admitValues?.kennelNumber === "" ||
      admitValues?.remark === "" ||
      admitValues?.vet === null
    ) {
      const reqObj = { kennelNumber: false, remark: false, vet: false };
      // if (admitValues?.kennelNumber === "") reqObj.kennelNumber = true;
      if (admitValues?.remark === "") reqObj.remark = true;
      if (admitValues?.vet === null) reqObj.vet = true;
      return setAdmitErrors(reqObj);
    }
    const data = {
      appointmentId: modalData?.appoinment?.appointmentId,
      kennelNumber: admitValues?.kennelNumber,
      remark: admitValues?.remark,
    };

    dispatch(
      admitPet({
        petId: modalData?.appoinment?.petId,
        vetId: admitValues?.vet?.value,
        data,
      })
    ).then((res) => {
      if (res?.payload) {
        dispatch(getClinicDashboardData({ type: selectedTab }));
        onCloseAdmitModal();
      }
    });
  };

  const handleChangeBookValue = (key, value) => {
    const reqValue =
      typeof value === "object"
        ? typeof value?.value === "number"
          ? value?.value?.toString()
          : value?.value
        : value;
    if (key === "appointmentOption" && value === "Immediate") {
      setSelectTimeIdError(false);
    }
    setBookValues({ ...bookValues, [key]: value });
    setErrors({
      ...errors,
      [key]: reqValue?.length > 0 ? false : "Required Field",
    });
  };

  const handleUploadComplete = async (url, apntId) => {
    await api({ contentType: true, auth: true })
      .get(`/appointment/${apntId}`)
      .then(async (getRes) => {
        if (getRes?.status === 200 || getRes?.status === 201) {
          if (getRes?.data?.data) {
            const reqObj = {
              appointment: {
                ...getRes?.data?.data,
                // caseSummary: url
              },
            };
            try {
              await superTailsApi.post("/appointment-completed", reqObj);
              setSelectedHistory(null);
              setPetData(null);
            } catch (supErr) {
              console.log("SuperTail Api Error", supErr);
            }
          }
        }
      });
  };

  return (
    <>
      <TopBar>
        <Container maxWidth="xl">
          <Grid container spacing={0} className="flex-center">
            <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
              <Grid container spacing={0}>
                <div className="flex-row">
                  <div
                    className="ph10pv3"
                    onClick={() => {
                      handleSelectedTab("Outpatient");
                    }}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "Outpatient"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Outpatient
                    </div>
                  </div>
                  <div
                    className="ph10pv3"
                    onClick={() => handleSelectedTab("Inpatient")}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "Inpatient"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Inpatient
                    </div>
                  </div>
                  <div
                    className="ph10pv3"
                    onClick={() => {
                      handleSelectedTab("Virtual");
                    }}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "Virtual"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Virtual
                    </div>
                  </div>

                  <div
                    className="ph10pv3"
                    onClick={() => handleSelectedTab("Home")}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "Home"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Home Visit
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
              {role === "ROLE_CLINIC" && (
                <div className="flex1-end">
                  <Grid item xs={8} sm={8} md={6} lg={4} xl={4}>
                    <Select
                      list={vetListWithAll}
                      value={selectedVet}
                      handleChange={(e, value) => {
                        const reqVal = value ?? allObj;
                        setSelectedVet(reqVal);
                        //for storing details to call socket
                        dispatch(
                          storeHomeScreenDetails({
                            selectedTab,
                            selectedVet:
                              selectedVet?.value !== "All"
                                ? reqVal?.value
                                : null,
                          })
                        );
                      }}
                      search
                    />
                  </Grid>
                </div>
              )}
            </Grid>
          </Grid>
        </Container>
      </TopBar>
      <div className="mv20">
        <Container maxWidth="xl">
          {selectedTab === "Inpatient" && (
            <InpatientNew
              setSelectedTab={setSelectedTab}
              selectedVet={selectedVet?.value}
            />
            // <Inpatient
            //   setSelectedTab={setSelectedTab}
            //   selectedVet={selectedVet?.value}
            // />
          )}
          {selectedTab === "Outpatient" && (
            <div className="flex-center">
              {renderSection(
                "Upcoming",
                filterAppointmentsByVet("upcomming"),
                "orange",
                "Upcoming",
                true,
                true
              )}
              {renderSection(
                "Checked-in",
                filterAppointmentsByVet("checkedin"),
                "rose",
                "Checked-in",
                true,
                true
              )}
              {renderSection(
                "Consultation",
                filterAppointmentsByVet("consultation"),
                "green",
                "Consultation",
                true,
                true
              )}
              {renderSection(
                "Billing",
                filterAppointmentsByVet("billings"),
                "yellow",
                "Billing",
                true,
                true
              )}
              {renderSection(
                "Completed",
                filterAppointmentsByVet("completed"),
                "paleGreen",
                "Completed",
                true,
                true
              )}
            </div>
          )}
          {selectedTab === "Virtual" && (
            <div className="flex-center">
              {renderSection(
                "Upcoming",
                filterAppointments(
                  filterAppointmentsByVet("upcomming"),
                  "Virtual"
                ),
                "orange",
                "Upcoming",
                false,
                false
              )}
              {renderSection(
                "Consultation",
                filterAppointments(
                  filterAppointmentsByVet("consultation"),
                  "Virtual"
                ),
                "green",
                "Consultation",
                false,
                false
              )}
              {renderSection(
                "Completed",
                filterAppointments(
                  filterAppointmentsByVet("completed"),
                  "Virtual"
                ),
                "paleGreen",
                "Completed",
                false,
                false
              )}
            </div>
          )}
          {selectedTab === "Home" && (
            <HomeVisit
              selectedTab={selectedTab}
              selectedVet={selectedVet}
              vets={vets}
            />
          )}
        </Container>
      </div>
      {selectedHistory ? (
        <MedicalHistoryView
          selectedHistory={selectedHistory}
          petData={petData}
          onUploadComplete={(e, apntId) => handleUploadComplete(e, apntId)}
        />
      ) : null}
      {followUpModVsble ? (
        <BookAnAppointment
          modalVisible={followUpModVsble}
          setBookModVisible={onCloseFollowUpMod}
          selectedPet={{
            petId: modalData?.appoinment?.petId,
            petName: modalData?.appoinment?.petName,
            petImage: modalData?.appoinment?.petImage,
            gender: modalData?.appoinment?.gender,
            breed: modalData?.appoinment?.breed,
            dob: modalData?.appoinment?.dob,
            userName: modalData?.appoinment?.userName,
          }}
          prevAppointmentId={modalData?.appoinment?.appointmentId}
        />
      ) : null}

      <CustomModal
        open={rescheduleModVsble}
        onClose={rescheduleModClose}
        header="Reschedule / Reassign"
        rightModal
        modalWidth={30}
        headerBold
      >
        <Grid container spacing={1} className="ph20 scroll-80vh">
          <Grid item xs={12}>
            <Card sx={cardSty} className="CustomCard-back-appointment">
              <div className="maint">
                <div className="flex-row">
                  <Grid item xs={3}>
                    <div className="flex-center">
                      {modalData?.appoinment?.petImage ? (
                        <CardMedia
                          image={modalData?.appoinment?.petImage}
                          className="CustomCard-img3-bill"
                        />
                      ) : (
                        <div className="flex-center h50img">
                          <Typography className="font-bold fs30 white-color capitalize">
                            {modalData?.appoinment?.petName?.[0]}
                          </Typography>
                        </div>
                      )}
                    </div>
                  </Grid>
                  <div className="flex-row">
                    <div className="flex-start">
                      <div className="flex-column">
                        <div className="flex-row">
                          <div className="mb10 txt-semi-bold black fs14 capitalize">
                            {modalData?.appoinment?.petName}
                          </div>
                          <Typography
                            className={`ml5 text capitalize ${
                              modalData?.appoinment?.gender === "male"
                                ? "card-blue-color"
                                : "card-rose-color"
                            }`}
                          >
                            {`(${modalData?.appoinment?.gender})`}
                          </Typography>
                        </div>
                        <Typography className="mb10 txt-regular card-gray-color fs12">
                          {modalData?.appoinment?.breed}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  <div></div>
                </div>
                <div>
                  <div className="flex-row parentcontainer mt10">
                    <div className="flex-row iconcontainer">
                      <AccountCircleOutlinedIcon
                        sx={{ width: 25, height: 25 }}
                      />
                      <div className="txt-semi-bold fs14 capitalize">
                        {modalData?.appoinment?.userName}
                      </div>
                    </div>
                    <div className="meeting-doctor">
                      {moment(modalData?.appoinment?.appointmentDate).fromNow()}{" "}
                      ({modalData?.appoinment?.appointmentDate})
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="txt-semi-bold fs14 light-grey">
              Booking Type <span className="red-color">*</span>
            </div>
            <Select value={bookValues?.bookingType} selectFixed />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="txt-semi-bold fs14 light-grey">
              Consultation Mode <span className="red-color">*</span>
            </div>
            <Select value={bookValues?.consultationMode} selectFixed />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 light-grey">
              Service Type <span className="red-color">*</span>
            </div>
            <Select value={bookValues?.serviceType} selectFixed />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 light-grey">
              Reason for visit <span className="red-color">*</span>
            </div>
            <Select value={bookValues?.reason} selectFixed />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {/* <div className="txt-semi-bold fs14 light-grey mb10">
              Vet Name <span className="red-color">*</span>
            </div> */}

            <Select
              list={vets}
              handleChange={(e, value) =>
                handleChangeBookValue("vetName", value)
              }
              name="vetName"
              search
              value={bookValues?.vetName}
              error={!!errors?.vetName}
              helperText={errors?.vetName}
              label="Vet Name *"
            />
          </Grid>
          {isReassign ? null : (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Appointment Time:{" "}
                {moment(
                  new Date(modalData?.appoinment?.appointmentdateTime)
                ).format("DD MMM YYYY HH:mm")}
              </div>
            </Grid>
          )}
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="mbminus"
          >
            <div className="flex-row">
              <div className="txt-semi-bold fs14 light-grey mt10">
                Appointment <span className="red-color">*</span> :
              </div>
              <div className="ml5">
                <CustomCheckbox
                  radio
                  value={bookValues?.appointmentOption}
                  onChange={(e) =>
                    handleChangeBookValue("appointmentOption", e?.target?.value)
                  }
                  radios={isReassign ? appointmentList : appointmentLaterList}
                  disabled={isReassign}
                  defaultValue={bookValues?.appointmentOption}
                />
              </div>
            </div>

            {!!errors?.appointmentOption && (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography color="error" className="mt5 fs14">
                  Appointment is Required
                </Typography>
              </Grid>
            )}
          </Grid>

          {!isReassign && bookValues?.appointmentOption === "Later" && (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-mont fs14 ">
                Date <span className="red-color">*</span>
              </div>
              <div className="mb20">
                <CustomTextField
                  name="date"
                  value={bookValues?.date}
                  labelTop
                  fullWidth
                  handleChange={(e) =>
                    handleChangeBookValue("date", e?.target?.value)
                  }
                  mobileDateWithBatch
                  markDateList={holidayDates ?? []}
                />
              </div>
            </Grid>
          )}

          {!isReassign &&
            bookValues?.appointmentOption === "Later" &&
            bookValues?.date &&
            getRequiredSlotList({
              availability: vetAvailability,
              date: bookValues?.date,
              bookedApnts: vetBookedApnts,
              holidays,
            })?.length > 0 &&
            getRequiredSlotList({
              availability: vetAvailability,
              date: bookValues?.date,
              bookedApnts: vetBookedApnts,
              holidays,
            })?.map((item, i) => {
              return (
                <div
                  key={i}
                  onClick={() => handleSelectTime(item)}
                  className={
                    selectTime === item?.startTime
                      ? "bgContainerSelected cursor"
                      : "bgContainerUnselected cursor"
                  }
                >
                  {item?.startTime}
                </div>
              );
            })}

          {selectTimeIdError && (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography color="error" className="mt5 fs14">
                Time is Requried
              </Typography>
            </Grid>
          )}
        </Grid>
        <div className="flex1-end mt20">
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <CustomButton text="Save" onClick={handleReschedule} />
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={admitModVisible}
        onClose={onCloseAdmitModal}
        header="Admit Patient"
        rightModal
        modalWidth={30}
        headerBold
      >
        <Grid container spacing={1} className="ph20">
          <Grid item xs={12}>
            <Card sx={cardSty} className="CustomCard-back-appointment">
              <div className="maint">
                <div className="flex-row">
                  <Grid item xs={3}>
                    <div className="flex-center">
                      {modalData?.appoinment?.petImage ? (
                        <CardMedia
                          image={modalData?.appoinment?.petImage}
                          className="CustomCard-img3-bill"
                        />
                      ) : (
                        <div className="flex-center h50img">
                          <Typography className="font-bold fs30 white-color capitalize">
                            {modalData?.appoinment?.petName?.[0]}
                          </Typography>
                        </div>
                      )}
                    </div>
                  </Grid>
                  <div className="flex-row">
                    <div className="flex-start">
                      <div className="flex-column">
                        <div className="flex-row">
                          <div className="mb10 txt-semi-bold black fs14 capitalize">
                            {modalData?.appoinment?.petName}
                          </div>
                          <Typography
                            className={`ml5 text capitalize ${
                              modalData?.appoinment?.gender === "male"
                                ? "card-blue-color"
                                : "card-rose-color"
                            }`}
                          >
                            {`(${modalData?.appoinment?.gender})`}
                          </Typography>
                        </div>
                        <Typography className="mb10 txt-regular card-gray-color fs12">
                          {modalData?.appoinment?.breed}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  <div></div>
                </div>
                <div>
                  <div className="flex-row parentcontainer mt10">
                    <div className="flex-row iconcontainer">
                      <AccountCircleOutlinedIcon
                        sx={{ width: 25, height: 25 }}
                      />
                      <div className="txt-semi-bold fs14 capitalize">
                        {modalData?.appoinment?.userName}
                      </div>
                    </div>
                    <div className="meeting-doctor">
                      {moment(modalData?.appoinment?.appointmentDate).fromNow()}{" "}
                      ({modalData?.appoinment?.appointmentDate})
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {/* <div className="txt-semi-bold fs14 light-grey">
              Kennel Number

            </div> */}
            <div className="mb20">
              <CustomTextField
                name="kennelNumber"
                value={admitValues?.kennelNumber}
                label="Kennel Number "
                fullWidth
                handleChange={(e) =>
                  handleAdmitChange("kennelNumber", e?.target?.value)
                }
                error={admitErrors?.kennelNumber}
                helperText={
                  admitErrors?.kennelNumber
                    ? "Kennel Number is required field"
                    : ""
                }
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {/* <div className="txt-semi-bold fs14 light-grey">
              Reason <span className="red-color">*</span>
            </div> */}
            <div className="mb20">
              <CustomTextField
                fullWidth
                multiline
                rows={3}
                handleChange={(e) =>
                  handleAdmitChange("remark", e?.target?.value)
                }
                label="Reason "
                required={true}
                value={admitValues?.remark ?? ""}
                error={admitErrors?.remark}
                helperText={
                  admitErrors?.remark ? "Reason is required field" : ""
                }
              />
            </div>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {/* <div className="txt-semi-bold fs14 light-grey mb10">
              Vet Name <span className="red-color">*</span>
            </div> */}
            <div className="mb20">
              <Select
                list={vets}
                handleChange={(e, value) => handleAdmitChange("vet", value)}
                name="vet"
                label="Vet Name *"
                search
                value={admitValues?.vet}
                error={admitErrors?.vet}
                helperText={
                  admitErrors?.vet ? "Vet Name is required field" : ""
                }
              />
            </div>
          </Grid>
        </Grid>
        <div className="flex1-end mt20">
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <CustomButton text="Save" onClick={handleAdmitPatient} />
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Cancel"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to cancel the appointment?
        </Typography>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton text="Yes" redBtn onClick={handleCancel} />
            </div>
            <div className="ml10">
              <CustomButton
                text={"No"}
                onClick={() => setDelModVisible(false)}
              />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </>
  );
};

export default Home;
